<template>
  <div id="modal-wrapper">
    <modal-component
      ref="modal"
      :custom-class="'add-edit-package-modal-wrapper'"
      :has-keyboard="true"
      :show-keyboard="true"
      @onModalClose="onModalClose"
    >
      <div id="add-edit-package-modal" class="modal-container package-modal">
        <div class="modal-header">
          {{ action === 'add' ? 'Add Package Plan' : 'Edit Package Plan' }}
        </div>

        <div class="package-modal__main">
          <div class="package-modal__info">
            <div class="package-modal__name">
              <div class="package-modal__icon">
                <icon-component
                  iconName="packageItem"
                />
              </div>

              <span class="label">
                {{ selectedPlan.name }}
              </span>
            </div>

            <div class="package-modal__price modal-price">
              <span class="modal-price__label">Price:</span>
              <span class="modal-price__value">
                ${{ Number.parseFloat(selectedPlan.price)?.toFixed(2) }}
              </span>
            </div>
          </div>

          <div class="package-modal__quantity quantity">
            <span class="quantity__label">Quantity:</span>

            <div class="quantity__buttons">
              <button
                class="quantity__button"
                :disabled="true"
                @click="count > 1 ? count-- : 1"
              >
                <icon-component iconName="minusBig"/>
              </button>

              <span class="quantity__count">{{ count }}</span>

              <button
                class="quantity__button"
                :disabled="true"
                @click="count++"
              >
                <icon-component iconName="plusBig"/>
              </button>
            </div>
          </div>
        </div>

        <div class="package-modal__common">
          <div
            v-if="[constants.legalAgeClasses.alcohol, constants.legalAgeClasses.tabacco].includes(parseInt(selectedPlan.legal_age_class))"
            class="detail">
            <span class="detail__label">Age Restriction:</span>
            <span class="detail__value">
                {{ selectedPlan.legal_age_class === 1 ? 'Drinking Age' : 'Tabacco Age' }}
              </span>
          </div>

          <div class="detail">
            <span class="detail__label">Auto Gratuity Amount:</span>
            <span class="detail__value">{{ selectedPlan.auto_gratuity_percent }}%</span>
          </div>
        </div>

        <div
          v-if="selectedPlan?.rules?.length > 0"
          class="package-modal__categories"
        >
          <div
            v-for="rule in selectedPlan.rules"
            class="package-modal__category"
          >
            <div class="package-modal__details details">
              <div class="details__category">
                <div
                  :class="['detail', { 'full': rule.type === constants.ruleTypes.discountable.key }]"
                >
                  <span class="detail__label">Package plan category:</span>
                  <span class="detail__value">
                      {{ getRuleCategoryLabel(rule.type) }}
                    </span>
                </div>

                <div
                  v-if="constants.ruleTypes.discountable.key === rule.type || constants.ruleTypes.percent_discountable.key === rule.type"
                  class="detail">
                  <span class="detail__label">Discount amount:</span>
                  <span class="detail__value">{{ rule?.discount_amount ?? 0 }}%</span>
                </div>

                <div
                  v-if="constants.ruleTypes.discountable.key === rule.type"
                  class="detail"
                >
                  <span class="detail__label">Max discountable item value:</span>
                  <span class="detail__value">${{ rule?.max_item_value ?? 0 }}</span>
                </div>

                <div
                  v-if="constants.ruleTypes.discountable.key === rule.type"
                  class="detail"
                >
                  <span class="detail__label">Daily amount:</span>
                  <span class="detail__value">{{ rule?.amount_daily_limit ?? 0 }} items (max)</span>
                </div>

                <div
                  v-if="constants.ruleTypes.free.key === rule.type"
                  class="detail">
                  <span class="detail__label">Number of $0.00 items/day:</span>
                  <span class="detail__value">{{ rule?.amount_daily_limit ?? 0 }}</span>
                </div>
              </div>
            </div>

            <div class="package-modal__applies applies">
              <span class="applies__label">Applies to</span>

              <table
                v-if="'departments' === selectedPlan.type"
                class="table applies__table departments"
              >
                <thead>
                <tr>
                  <th class="th_department">Department</th>
                  <th class="th_sub_department">Subdepartment</th>
                  <th class="th_items">items</th>
                </tr>
                </thead>
                <tbody>

                <template
                  v-for="group in getRuleAppliesItems(rule)"
                >
                  <tr
                    v-for="(item, itemIdx) in group"
                  >
                    <td
                      v-if="0 === itemIdx"
                      class="td_name"
                      :rowspan="group?.length"
                    >
                      {{ item?.name }}
                    </td>

                    <td>
                      {{ item?.sub_department?.name }}
                    </td>

                    <td>
                      All items
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>

              <table
                v-if="'items' === selectedPlan.type"
                class="table applies__table items"
              >
                <thead>
                <tr>
                  <th class="th_department">Department</th>
                  <th class="th_id">ID</th>
                  <th class="th_items">Item Name</th>
                </tr>
                </thead>
                <tbody>

                <template
                  v-for="item in getRuleAppliesItems(rule)"
                  :key="item.id"
                >
                  <tr>
                    <td>{{ item.department.name }}</td>

                    <td>{{ item.id }}</td>

                    <td>{{ item.name }}</td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          class="modal-controls">
          <base-button
            v-if="action === 'edit' && !isWaiterAssist && selectedOrder.items.length > 1"
            text="Delete"
            classes="def-btn delete-action-btn uppercase medium border-2"
            @onClick="deletePackagePlan"
          />

          <base-button
            text="CANCEL"
            classes="def-btn cancel-action-btn uppercase medium border-2"
            @onClick="closeModal"
          />

          <base-button
            :text="action === 'add' ? 'ADD PACKAGE PLAN' : 'CONFIRM'"
            classes="def-btn main-action-btn uppercase medium border-2"
            @onClick="addConfirmPackagePlan"
          />
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
import ModalComponent from "@/components/_shared/Modal";
import CancelOrderModal from "@/components/_modals/CancelOrderModal";
import BaseButton from "@/components/_shared/Button.vue";
import iconComponent from "@/components/_shared/Icon.vue";
import { constants } from '@/constants/constants';
import { packagePlansService } from '@/_api/packagePlans.api';
import { usersService } from '@/_api/users.api';

export default {
  name: 'AddEditPackageModal',

  emits: ['addEditItem', 'onModalClose', 'deleteItem'],

  components: {
    ModalComponent,
    CancelOrderModal,
    BaseButton,
    iconComponent,
  },

  props: {
    selectedOrder: {
      type: Object,
      require: true
    },

    selectedPlan: {
      type: Object,
      require: true
    },

    action: {
      type: String,
      require: true,
      default: 'add'
    },
  },

  data() {
    return {
      count: 1,

      usersInCabin: null,
    }
  },

  computed: {
    constants() {
      return constants;
    },

    isWaiterAssist() {
      return this.$store.state.auth.user.user.role === 'waiter assist';
    },
  },

  watch: {
    selectedOrder: {
      async handler() {
        const cabin = this.selectedOrder?.payers?.[0]?.cabin;

        if (!cabin) {
         return;
        }

        try {
          const { data } = await usersService.getUsersInCabin(cabin);
          this.usersInCabin = data?.data;
        } catch (error) {
          console.log('error', error)
        }
      },

      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.emmiter.on('closeModal', () => {
      if (this.$refs['modal']) {
        this.closeModal();
      }
    });
  },

  beforeUnmount() {
    this.showDelNoticeModal = false;
    this.emmiter.off('closeModal');
    this.emmiter.emit('toggleModals', { opened: false, type: 'AddEditPackageModal' });
  },

  methods: {
    openModal() {
      this.$refs['modal'].show();
      this.emmiter.emit('toggleModals', { opened: true, type: 'AddEditPackageModal' });
    },

    async addConfirmPackagePlan() {
      const hasSelectedPlanContainsAgeRestriction = [constants.legalAgeClasses.alcohol, constants.legalAgeClasses.tabacco].includes(parseInt(this.selectedPlan.legal_age_class));

      if (hasSelectedPlanContainsAgeRestriction) {
        const result = await this.checkCanSellPackagePlanByAgeRestriction();

        if (!result) {
          return;
        }
      }

      const existPackagePlans = [];
      this.selectedOrder?.items?.forEach((item) => {
        if (existPackagePlans.includes(item.package_plan_id)) {
          return;
        }

        existPackagePlans.push(item.package_plan_id);
      });

      const payload = {
        crew_id: this.selectedOrder?.serviced_by?.id,
        package_plans: [
          ...existPackagePlans,
          this.selectedPlan.id
        ],
      }

      if (this.selectedOrder?.payers?.length) {
        payload.payers = this.selectedOrder?.payers?.map((payer) => {
          return {
            user_profile_id: payer.id,
            addition_mode_id: payer.addition_mode?.id || constants.payerAddedModes[0].id,
          };
        });
      }

      this.$emit('addEditItem', {
        currentOrder: this.selectedOrder,
        payload: payload,
        needSellEveryInCabin: this.needSellEveryInCabin(payload),
      });

      this.closeModal();
    },

    needSellEveryInCabin() {
      const usersInCabin = this.usersInCabin?.filter((payer) => {
        if (!this.selectedPlan?.legal_age_class) {
          return true;
        }

        const legalAge = this.selectedPlan.legal_age_class === constants.legalAgeClasses.alcohol
          ? this.$store.getters.legalAge.ADDITION_LEGAL_AGE_ALCOHOL
          : this.$store.getters.legalAge.ADDITION_LEGAL_AGE_TABACCO;

        return Boolean(payer?.age <= 0 || (payer?.age >= legalAge))
      });

      return usersInCabin?.length > 1;
    },

    async checkCanSellPackagePlanByAgeRestriction() {
      if (!this.canSoldAlcoholByAgeRestriction(this.selectedOrder.payers)) {
        this.emmiter.emit('showConfirm', 'alcohol-payer');

        this.closeModal();
        return false;
      }

      if (!this.canSoldTabaccoByAgeRestriction(this.selectedOrder.payers)) {
        this.emmiter.emit('showConfirm', 'tabacco-payer');

        this.closeModal();

        return false;
      }

      return true;
    },

    canSoldAlcoholByAgeRestriction(payers) {
      return payers?.every((payer) => {
        return Boolean(payer?.age <= 0 || (payer?.age >= this.$store.getters.legalAge.ADDITION_LEGAL_AGE_ALCOHOL))
      })
    },

    canSoldTabaccoByAgeRestriction(payers) {
      return payers?.every((payer) => {
        return Boolean(payer?.age <= 0 || (payer?.age >= this.$store.getters.legalAge.ADDITION_LEGAL_AGE_TABACCO))
      })
    },

    closeModal() {
      this.emmiter.emit('toggleModals', { opened: false, type: 'AddEditPackageModal' });
      this.$emit('onModalClose');
      this.$refs['modal'].close();
    },

    deletePackagePlan() {
      // this.$emit('deleteItem', {
      //   type: 'update',
      //   id: this.deepCopy.id,
      //   orderId: this.selectedOrder.id
      // })
    },

    getRuleCategoryLabel(type) {
      const finedType = Object.values(this.constants.ruleTypes)?.find((ruleType) => {
        return ruleType?.key === type;
      });

      return finedType?.label ?? '';
    },

    getRuleAppliesItems(rule) {
      const isItems = Boolean(this.selectedPlan.type === 'items');

      if (isItems) {
        return rule?.items
      }

      return Object.groupBy(rule.departments, department => department.id);
    },
  }
}
</script>

<style lang="less" scoped>
#modal-wrapper {
  :deep(.add-edit-package-modal-wrapper) {
    .c-modal {
      justify-content: flex-start;
      padding: 5px;

      .window {
        margin-bottom: 0;
        width: 1024px;
        padding: 24px 35px;
        border-radius: 8px;
        max-height: 744px;
      }
    }
  }

  #add-edit-package-modal {
    background-color: white;

    * > {
      font-family: 'Segoe UI', sans-serif;
    }

    .modal-header {
      font-weight: 300;
      margin: 0;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

    }

    .modal-controls {
      column-gap: 30px;

      button {
        width: 100%;
      }
    }

    &.package-modal {
      display: flex;
      flex-direction: column;

      width: 100%;
    }

    .package-modal {
      &__main {
        display: grid;
        column-gap: 4px;
        grid-template-columns: 464px 468px;

        justify-content: space-between;

        padding-top: 8px;
      }

      &__info {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 13px;
      }

      &__name {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        font-size: 18px;
        font-weight: 600;
        line-height: 18px;
        width: 100%;

        .label {
          font-size: 18px;
          font-weight: 600;
          line-height: 18px;

          letter-spacing: -0.4px;
          padding-left: 13px;
        }
      }

      &__price {
        padding-top: 12px;
      }

      &__icon {
        width: 156px;
        height: 108px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      &__quantity {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
      }

      &__categories {
        display: flex;
        flex-direction: column;

        max-height: 323px;
        overflow-y: auto;
        padding-bottom: 35px;
      }

      &__category {
        display: flex;
        flex-direction: column;
      }

      &__details {
        padding-top: 20px;
      }

      &__applies {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        padding-top: 20px;
      }

      &__common {
        padding-top: 35px;
        display: flex;
        flex-direction: row;
        column-gap: 30px;
        border-bottom: 1px solid #E5E0EB;
        padding-bottom: 15px;
      }
    }
  }

  .modal-price {
    width: 100%;
    display: grid;
    grid-template-columns: 0.6fr 0.4fr;

    &__label {
      font-size: 14px;
    }

    &__value {
      font-size: 18px;
    }

    &__label, &__value {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      text-transform: uppercase;
    }
  }

  .quantity {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 2px 0 0;

    &__count {
      font-size: 18px;
      font-weight: 400;
      line-height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 6px 24px;
      margin: 0 5px;

      background-color: #ECF4F9;
      border-radius: 4px;
    }

    &__label {
      font-size: 14px;
      font-weight: 400;

      padding-right: 8px;

      text-transform: uppercase;
    }

    &__buttons {
      display: flex;
      flex-direction: row;
      align-items: center;

      background-color: transparent;
      border: none;
      outline: none;

      &:focus, &:hover {
        background-color: transparent;
        border: none;
        outline: none;
      }
    }

    &__button {
      border: none;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      padding: 0;

      &:disabled {
        opacity: 0.3;
        pointer-events: none;
      }
    }
  }

  .details {
    display: flex;
    flex-direction: column;

    &__category {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      column-gap: 40px;
      padding-top: 16px;
      row-gap: 10px;
    }
  }

  .detail {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    column-gap: 4px;

    &.full {
      width: 100%;
    }

    &__label, &__value {
      font-size: 18px;
      font-weight: 400;
    }

    &__value {
      font-weight: 600;
      letter-spacing: -0.3px;
    }
  }
}

.applies {
  &__label {
    font-size: 18px;
    padding-bottom: 10px;
  }

  &__table {
    &.departments {
      .th_department {
        width: 33.6%;
      }

      .th_sub_department {
        width: 31.7%;
      }

      .th_items {
        width: 34.7%;
      }
    }

    &.items {
      .th_department {
        width: 25.35%;
      }

      .th_sub_department {
        width: 38.5%;
      }

      .th_id {
        width: 7.5%;
      }

      .th_items {
        width: 28.7%;
      }
    }
  }
}

.table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    border-top: 2px solid #E5E0EB;
    border-bottom: 2px solid #E5E0EB;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    display: table-header-group;
    overflow: auto;

    tr {
      th {
        border: 1px solid #E5E0EB;
        padding: 12px 4px;
        vertical-align: middle;

        font-size: 13px;
        font-weight: 600;
        text-align: left;

        &:first-child {
          border-left: none;
        }

        &:last-child {
          border-right: none;
        }
      }
    }
  }

  tbody {
    display: table-row-group;
    overflow: auto;

    tr {
      td {
        border: 1px solid #E5E0EB;
        padding: 10px 3px;
        vertical-align: middle;
        text-align: left;
        font-weight: 500;
        font-size: 14px;

        &:first-child {
          border-left: none;
        }

        &:last-child {
          border-right: none;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  #modal-wrapper {
    #add-edit-item-modal {
      h1 {
        font-size: 36px;
      }
    }
  }
}

@media (max-width: 850px) {
  #modal-wrapper {
    #add-edit-item-modal {
      min-width: 480px;
    }
  }
}
</style>
